import { GigsafeUsersTableFields } from './enums'

export const gigsafeUsersTableHeaderTitles: Record<GigsafeUsersTableFields, string> = {
  [GigsafeUsersTableFields.id]: 'ID',
  [GigsafeUsersTableFields.name]: 'Name',
  [GigsafeUsersTableFields.email]: 'Email',
  [GigsafeUsersTableFields.disabled]: 'Disabled',
  [GigsafeUsersTableFields.disabledAt]: 'Disabled at',
}

// 20 first, matching both Retool's page size and the backend's own default
// (`GetGigSafeUsersFilterDto` transforms a missing limit to 20).
export const gigsafeUserPageSizeOptions = [20, 50, 100]

export const GIGSAFE_USERS_GRID_COLUMNS_STORAGE_KEY = 'admin.gigsafeUsers.gridColumns'
